import { Basic } from "../basic.ts";
import styles from './trend.css'
/**
 * @class MSToolbar
 * @extends Basic
 * @classdesc Панель инструментов
 * */
export class MSToolbar extends Basic {
    static get observedAttributes() {
        return super.observedAttributes.concat(["buttons"]);
    }
    constructor() {
        super();
        this.elements = {};
        this.shRoot = this.attachShadow({ mode: "open" });
        this.shRoot.innerHTML =
            `<style>
                ${styles}
            </style>
            <style>
                :host {
                    overflow: visible !important;
                }
            </style>
            <div id="toolbar" style="border-width: 0px; width: 100%; height: 30px; display: flex; align-items: center;"></div>
        `;
        this._main = this.shRoot.querySelector("#toolbar");
        this.style.borderWidth = 0;

        this.controller = new AbortController();
        this.signal = this.controller.signal;
    }
    /**
     * Кнопки
     * @type {string}
     */
    get buttons() {
        return this._buttons;
    }
    set buttons(value) {
        this._buttons = JSON.parse(value);
        this._buttons.forEach((element) => {
            switch (element.type) {
                case "button":
                    this.addButton(
                        element.method,
                        element.class,
                        element.tooltip,
                        element.svg
                    );
                    break;
                case "toggle":
                    this.addToggle(
                        element.method,
                        element.class,
                        element.tooltip,
                        element.id,
                        element.svg
                    );
                    break;
                case "expander":
                    this.addExpander();
                    break;
            }
        });
    }
    /**
     * Позиция тулбара (задел на будущее)
     * @type {enum}
     */
    get position() { }
    set position(value) { }

    get height() {
        return this._main.style.height;
    }
    set height(value) {
        super.height = value;
        this._main.style.height = this._setValueUnit(value);
        this.style.minHeight = this._setValueUnit(value);
        this.style.maxHeight = this._setValueUnit(value);
    }
    /**
     * Контекст панели инструментов (Тренд)
     * @type {HTMLElement}
     */
    get context() {
        return this._context;
    }
    set context(value) {
        this._context = value;
        for (const [methodName, btn] of Object.entries(this.elements)) {
            if (this._context[methodName]) {
                btn.addEventListener('click', this._context[methodName].bind(this._context), {
                    signal: this.signal
                });
            }
        }
    }

    /**
     * Видимость
     * @type {bool}
     */
    get isvisible() {
        return this._showElement;
    }
    set isvisible(value) {
        this._showElement = value;
        this.style.display = value ? "" : "none";
    }

    /**
     * цвет иконок
     * @type {bool}
     */
    get coloricon() {
        return this._coloricon
    }

    set coloricon(value) {
        this._coloricon = value;
        this._main.style.setProperty('--icon-color', value);
    }

     /**
     * цвет background
     * @type {bool}
     */
     get backgroundcolor() {
        return this._backgroundcolor
    }

    set backgroundcolor(value) {
        this._backgroundcolor = value;
        this._main.style.backgroundColor = value;
    }

    /**
     * Добавить кнопку в панель инструментов
     * @param {string} methodname название функции для вызова по клику на кнопку
     * @param {string} classname имя класса (символ) кнопки
     * @param {string} tooltip всплывающая подсказка
     * @param {string} svg иконка(необязательная)
     */
    addButton(methodname, classname, tooltip, svg) {
        const button = document.createElement("div");
        button.dataset.tooltip = tooltip;
        button.style.width = 30;
        button.style.height = 30;
        button.className = classname;
        button.classList.add("btn");
        button.addEventListener('mouseenter', () => this.toolTipShow(button), { signal: this.signal })
        button.addEventListener('mouseleave', () => this.hideTooltip(), { signal: this.signal })
        this._main.appendChild(button);
        this.elements[methodname] = button;
        if(svg){
            button.innerHTML = svg;
        }
    }
    /**
     * Добавить кнопку-переключатель в панель инструментов
     * @param {string} methodname название функции для вызова по клику на кнопку
     * @param {Array} classname 2 имени класса (символа) для каждого состояния кнопки
     * @param {Array} tooltip 2 всплывающые подсказки для каждого состояния кнопки
     */
    addToggle(methodname, classname, tooltip, id = null, svg) {
        const button = document.createElement("div");
        if (id) button.setAttribute('id', id);
        button.classnames = classname;
        button.tooltips = tooltip;
        button.classList.add("btn");
        button.addEventListener('mouseenter', () => this.toolTipShow(button), { signal: this.signal })
        button.addEventListener('mouseleave', () => this.hideTooltip(), { signal: this.signal })
        button.dataset.tooltip = tooltip[0];
        button.style.width = 30;
        button.style.height = 30;
        button.classList.add(classname[0]);
        this._main.appendChild(button);
        this.elements[methodname] = button;
        if(svg){
            button.innerHTML = svg;
        }
    }
    /**
     * Задать состояние для кнопки-переключателя
     * @param {HTMLElement} button кнопка для задания состояния
     * @param {boolean} state состояние (вкл/выкл)
     */
    setToggleState(button, state) {
        const newBtnMethod = Object.entries(this.elements).find(([method, btn]) => btn === button)[0];
        if (!state) {
            button.classList.remove("active");
            button.classList.remove(button.classnames[1]);
            button.classList.add(button.classnames[0]);
            button.dataset.tooltip = button.tooltips[0]
            if (this.tooltipElement && this.tooltipElement.dataset.currentBtnMethod === newBtnMethod)
                this.tooltipElement.innerHTML = button.tooltips[0];
        } else {
            button.classList.add("active");
            button.classList.remove(button.classnames[0]);
            button.classList.add(button.classnames[1]);
            button.dataset.tooltip = button.tooltips[1]
            if (this.tooltipElement && this.tooltipElement.dataset.currentBtnMethod === newBtnMethod)
                this.tooltipElement.innerHTML = button.tooltips[1];
        }
    }
    /**
     * Задать видимость кнопки
     * @param {HTMLElement} button кнопка
     * @param {boolean} state видимость
     */
    setVisible(button, state) {
        if(button){
            if (!state) {
                button.style.display = "none";
            } else {
                button.style.display = "";
            }
        }
    }
    /**
     * Задать активность кнопки
     * @param {HTMLElement} button кнопка
     * @param {boolean} state активность
     */
    setEnable(button, state) {
        if(button){
            if (!state) {
                button.classList.add("disable");
            } else {
                button.classList.remove("disable");
            }
        }
    }
    /**
     * Добавить разделитель
     * */
    addExpander() {
        const exp = document.createElement("div");
        exp.style.flex = "1";
        this._main.appendChild(exp);
    }

    toolTipShow(target) {
        const tooltipHtml = target.dataset.tooltip;
        if (!tooltipHtml) {
            return;
        }

        this.buildTooltip(tooltipHtml);
        this.tooltipElement.dataset.currentBtnMethod = Object.entries(this.elements).find(([method, btn]) => btn === target)?.[0];
        this.setTooltipPosition(target);
    }

    disconnectedCallback() {
        this.controller.abort();
        delete this._context;
    }
}
